import * as attw from "@arethetypeswrong/core";
import * as publint from "publint";
import * as publintUtils from "publint/utils";
import ApiSnapshot from "tsnapi/rolldown";
import type { UserConfig } from "vite-plus";

import type { LibOptions } from ".";

export const PACK_BANNER = "/*! Keep it simple, keep it free */";
export const PACK_FOOTER = "/*! Built with love & coffee ☕ */";

export const packPreset = (options: LibOptions): UserConfig["pack"] => {
  const { entry = "index", inlineDeps = [] } = options;
  return {
    attw: {
      enabled: true,
      profile: "esm-only",
      module: attw,
    },
    banner: PACK_BANNER,
    deps: { onlyBundle: inlineDeps },
    devtools: true,
    dts: {
      tsgo: true,
    },
    entry:
      entry === "index"
        ? "src/index.ts"
        : entry === "shallow"
          ? "src/*.ts"
          : entry === "all"
            ? "src/**/*.ts"
            : entry,
    exports: {
      packageJson: true,
      legacy: true,
    },
    footer: PACK_FOOTER,
    platform: "neutral",
    plugins: [ApiSnapshot()],
    publint: {
      enabled: true,
      module: [publint, publintUtils],
    },
    shims: true,
    sourcemap: true,
    unbundle: true,
    unused: true,
  };
};
